type AuthEventCallback = () => void;

const tokenExpiredListeners: AuthEventCallback[] = [];

export const onTokenExpired = (callback: AuthEventCallback): (() => void) => {
	tokenExpiredListeners.push(callback);
	return () => {
		const index = tokenExpiredListeners.indexOf(callback);
		if (index > -1) tokenExpiredListeners.splice(index, 1);
	};
};

export const emitTokenExpired = (): void => {
	tokenExpiredListeners.forEach((cb) => cb());
};
